<template>
  <div class="video-control-container">
    <!-- (1) PageHeader -->
    <ds-page-header :title="$t('videoControl.page.title')" :subtitle="$t('videoControl.page.subtitle')" />

    <!-- (2) 视频控制面板 -->
    <div class="ds-panel ds-panel--padded">
      <camera-control-video ref="cameraControl" />
    </div>
  </div>
</template>

<script>
import CameraControlVideo from '@/components/machine/cameraControlVideo.vue'
import DsPageHeader from '@/components/ds/ds-page-header.vue'

export default {
  name: 'VideoControlList',
  components: {
    CameraControlVideo,
    DsPageHeader
  },
  data() {
    return {
      communityId: ''
    }
  },
  created() {
    this.getCommunityId()
  },
  methods: {
    async getCommunityId() {
      try {
        const { getCommunityId } = await import('@/api/community/communityApi')
        this.communityId = getCommunityId()
      } catch (error) {
        console.error('Failed to get communityId:', error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.video-control-container {
  padding: var(--ds-spacing-lg);
  background-color: var(--ds-gray-100);
  min-height: calc(100vh - 60px);
}

.ds-panel {
  background: #fff;
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
  overflow: hidden;
  margin-bottom: var(--ds-spacing-lg);

  &--padded {
    padding: var(--ds-spacing-lg);
  }
}
</style>
